import React, { PureComponent } from 'react';
import { string, bool, func } from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Radium from 'radium';
import { Link } from 'react-router-dom';
import { isMobile } from '@widergy/web-utils/lib/browser';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import { gaTrackPageView } from 'services/AnalyticsService';
import AuthFormBox from 'app/components/AuthFormBox';
import { ROUTES } from 'constants/routes';
import { SIGN_IN_FORM } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';
import Images from 'config/assets';
import { MobileBreakpoint } from 'constants/deviceSizes';

import SignIn from './layout';
import stylesJS from './styles';
import styles from './styles.module.scss';

const DOCUMENT_TYPE = 'document_type';
const DOCUMENT_NUMBER = 'document_number';

const publicHome = appConfig.publicDashboard.home ? ROUTES.PUBLIC_HOME : ROUTES.PUBLIC_PAYMENTS;

const SOCIAL_NETWORKS = appConfig.signIn.showSocialNetworks && [
  { link: appConfig.signIn.socialNetworks.facebook, icon: Images.facebook },
  { link: appConfig.signIn.socialNetworks.twitter, icon: Images.twitter },
  { link: appConfig.signIn.socialNetworks.linkedin, icon: Images.linkedin }
];

class SignInContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: isMobile(MobileBreakpoint) ? message('Signin:loginMobile') : message('Signin:login')
    };
    window.addEventListener('resize', this.updateTitleText);
  }

  componentDidMount() {
    gaTrackPageView(ROUTES.SIGN_IN);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateTitleText);
  }

  updateTitleText = () =>
    this.setState({
      title: isMobile(MobileBreakpoint) ? message('Signin:loginMobile') : message('Signin:login')
    });

  render() {
    const { handleSubmit, loading, documentType, documentNumber, submitFailed, invalid } = this.props;

    return (
      <form onSubmit={handleSubmit} onKeyDown={handleKeyDown(handleSubmit)} style={stylesJS.container}>
        <AuthFormBox title={this.state.title}>
          <SignIn loading={loading} documentType={documentType} documentNumber={documentNumber} />
        </AuthFormBox>
        {!loading && (
          <React.Fragment>
            <UTButton
              disabled={submitFailed && invalid}
              key="submit"
              className={`${styles.submit} ${submitFailed && invalid && styles.submitFailure}`}
              uppercase
              type="submit"
            >
              {message('Signin:signIn')}
            </UTButton>
            <Link style={stylesJS.link} to={ROUTES.SIGN_IN_PASSWORD_RECOVERY}>
              <UTLabel small semibold primary>
                {message('Signin:forgotPassword')}
              </UTLabel>
            </Link>
            <Link style={stylesJS.link} to={ROUTES.SIGN_UP}>
              <UTLabel small semibold darkGray>
                {`${message('Signin:noAccount')}, `}
              </UTLabel>
              <UTLabel small semibold primary>
                {message('Signin:register')}
              </UTLabel>
            </Link>
            <Link style={stylesJS.link} to={publicHome}>
              <UTLabel small semibold primary>
                {message('Signin:continueWithoutRegistering')}
              </UTLabel>
            </Link>
            {appConfig.signIn.showSocialNetworks && (
              <div style={stylesJS.socialNetworks}>
                <UTLabel small primary>
                  {message('Landing:socialNetworks')}
                </UTLabel>
                {SOCIAL_NETWORKS.map(socialNetwork => (
                  <a
                    key={socialNetwork.link}
                    href={socialNetwork.link}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img src={socialNetwork.icon} alt="" style={stylesJS.socialIcon} />
                  </a>
                ))}
              </div>
            )}
          </React.Fragment>
        )}
      </form>
    );
  }
}

SignInContainer.propTypes = {
  handleSubmit: func.isRequired,
  loading: bool,
  documentType: string,
  documentNumber: string,
  submitFailed: bool,
  invalid: bool
};

const formSelector = formValueSelector(SIGN_IN_FORM);

const mapStateToProps = store => ({
  documentType: formSelector(store, DOCUMENT_TYPE),
  documentNumber: formSelector(store, DOCUMENT_NUMBER),
  loading: store.auth.sessionLoading || store.auth.signInLoading
});

export default connect(mapStateToProps)(reduxForm({ form: SIGN_IN_FORM })(Radium(SignInContainer)));
